import React from "react";
import { useUi } from "@jelly/lesson";
import styles from "./CarouselModal.module.scss";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { Modal } from "@jelly/ui";

type CarouselModalProps = Omit<React.ComponentProps<typeof Modal>, "children"> & { children: React.ReactNode[] };

export const CarouselModal: React.FC<CarouselModalProps> = (props) => {
  const ui = useUi();

  const { children, ...rest } = props;

  return (
    <ui.Modal {...rest}>
      <div className={styles.content}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
        <SpatialCarousel controlsPosition={"bottom-wide"} showBreadcrumbs>
          {children.map((child, index) => (
            <div key={index} className={styles.carouselItem}>
              {child}
            </div>
          ))}
        </SpatialCarousel>
      </div>
    </ui.Modal>
  );
};

//TODO: override X button style
//TODO: override carousel controls style
